import styled, { css } from 'styled-components/macro';
import { fontSize } from '../../styles/mixins';
import media from '../../styles/media';

const whichArrow = (direction, inverse, theme) =>
  ({
    up: `border-bottom-color:
  ${inverse ? theme.buttonArrowColorInverse : theme.buttonArrowColor}`,
    down: `border-top-color:
  ${inverse ? theme.buttonArrowColorInverse : theme.buttonArrowColor}`,
    left: `border-right-color:
  ${inverse ? theme.buttonArrowColorInverse : theme.buttonArrowColor}`,
    right: `border-left-color:
  ${inverse ? theme.buttonArrowColorInverse : theme.buttonArrowColor}`,
  }[direction]);

export const ButtonContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: 70px;
  width: 140px;
  background-color: ${({ inverse, theme }) =>
    inverse ? theme.buttonBgColorInverseLight : theme.buttonBgColorLight};
  border: 1px solid
    ${({ inverse, theme }) =>
      inverse ? theme.buttonBgColorInverseLight : theme.buttonBgColorLight};
  color: ${({ inverse, theme }) =>
    inverse ? theme.buttonTextColorInverse : theme.buttonTextColor};
  border-radius: 3px;
  box-shadow: 1px 1px 1px 0 rgba(0, 0, 0, 0.1);
  padding: 8px;
  cursor: pointer;
  &::before {
    ${({ hasArrow }) =>
      hasArrow &&
      css`
        content: '';
        border-color: transparent;
        border-width: ${({ arrowSize }) => `${arrowSize}px`};
        border-style: solid;
        ${({ arrowDirection, inverse, theme }) =>
          whichArrow(arrowDirection, inverse, theme)};
        width: 0;
        height: 0;
      `};
  }

  i {
    color: ${({ inverse, theme }) =>
      inverse ? theme.buttonIconColorInverse : theme.buttonIconColor};
  }

  &:hover {
    color: ${({ inverse, theme }) =>
      inverse ? theme.buttonTextColorHoverInverse : theme.buttonTextColorHover};

    i {
      color: ${({ inverse, theme }) =>
        inverse ? theme.buttonIconColorInverse : theme.buttonIconColorHover};
    }
  }

  &.disabled,
  &.disabled:hover {
    color: ${({ theme }) => theme.buttonTextColorDisabled};
    background-color: ${({ theme }) => theme.buttonBgDisabled};
    cursor: not-allowed;
    border-color: ${({ theme }) => theme.buttonBorderColorDisabled};
  }

  ${media.desktop`
    width: 180px;
    height: 90px;
    padding-top: 15px;
    padding-bottom: 10px;
  `};
`;

export const IconsContainer = styled.div`
  display: flex;
  flex-direction: row;
  flex-grow: 1;
  justify-content: space-between;

  i {
    ${fontSize(25)};

    ${media.desktop`
      ${fontSize(33)};
    `};
  }

  .arrow {
    margin-top: 7px;
  }
`;

export const TextContainer = styled.p`
  ${fontSize(14)};
  font-weight: normal;
`;

export const FlatButtonContainer = styled(ButtonContainer)`
  background-color: ${({ inverse, theme }) =>
    inverse ? theme.buttonBgColorInverse : theme.buttonBgColor};
  box-shadow: 0;
  border: 1px solid ${({ theme }) => theme.buttonBorderColor};
  color: ${({ inverse, theme }) =>
    inverse ? theme.buttonTextColorInverse : theme.buttonTextColor};
  flex-direction: ${({ column }) => (column ? 'column' : 'row')};
  ${({ margin }) => margin && 'margin-right: 12px;'}
  padding-right: 15px;
  padding-left: 15px;
  ${media.desktop`
    ${({ margin }) => margin && 'margin-right: 40px;'}
    padding-bottom: 15px;
  `};
  padding-bottom: 20px;
  ${({ back }) => back && 'flex-direction: row-reverse;'}
  &:hover {
    color: ${({ inverse, theme }) =>
      inverse ? theme.buttonTextColorInverse : theme.buttonColorHover};
    background-color: ${({ inverse, theme }) =>
      inverse ? theme.buttonBgHover : theme.buttonBg};
    border-color: ${({ theme }) => theme.buttonBorderHoverColor};

    i {
      color: ${({ inverse, theme }) =>
        inverse ? theme.buttonIconColorInverse : theme.buttonIconColorHover};
    }
  }
  &::before {
    ${({ back }) => (back ? 'right: 100%;' : 'left: 100%;')}
    position: relative;
  }
`;

export const FlatTextContainer = styled(TextContainer)`
  font-weight: normal;
  max-width: 50%;
  margin-top: auto;
  ${fontSize(16)};
  ${({ back }) => back && 'text-align: end;'}
  ${media.desktop`
  padding-right: 35px;
  `}
`;
